import React from 'react';
import { motion } from 'framer-motion';
import usePerformanceOptimization from '../../hooks/usePerformanceOptimization';
import useLazyAnimation from '../../hooks/useLazyAnimation';

const FloatingElements = ({
  count = 3,
  colors = ['#00D4FF', '#8B5CF6', '#00FF88', '#FF6B00'],
  className = ''
}) => {
  const { shouldReduceAnimations } = usePerformanceOptimization();
  const { elementRef, shouldLoad } = useLazyAnimation({
    delay: 800,
    threshold: 0.1
  });

  const optimizedCount = shouldReduceAnimations ? Math.min(count, 2) : count;

  const elements = Array.from({ length: optimizedCount }, (_, i) => ({
    id: i,
    color: colors[i % colors.length],
    size: Math.random() * (shouldReduceAnimations ? 25 : 40) + 15,
    x: Math.random() * 100,
    y: Math.random() * 100,
    duration: Math.random() * (shouldReduceAnimations ? 15 : 10) + (shouldReduceAnimations ? 30 : 20),
    delay: Math.random() * (shouldReduceAnimations ? 1 : 3),
  }));

  return (
    <div ref={elementRef} className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {shouldLoad && elements.map((element) => (
        <motion.div
          key={element.id}
          className="absolute rounded-full opacity-20 will-change-transform"
          style={{
            width: element.size,
            height: element.size,
            backgroundColor: element.color,
            left: `${element.x}%`,
            top: `${element.y}%`,
            boxShadow: shouldReduceAnimations ? 'none' : `0 0 ${element.size}px ${element.color}`,
          }}
          animate={shouldReduceAnimations ? false : {
            y: [0, -15, 0],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={shouldReduceAnimations ? {} : {
            duration: element.duration * 2,
            repeat: Infinity,
            delay: element.delay,
            ease: "linear",
          }}
        />
      ))}
    </div>
  );
};

export default FloatingElements;
